import { useContext, useState } from 'react'
import Map from '../../components/mapcompo/Mapcompo';
import styles from './online.module.css'
import { TotalDriverContext } from './totalOnlineContext';

const OnlineDriverslocation = () => {
    const [checkRadius, setCheckRadius] = useState(false)

    const { locations } = useContext(TotalDriverContext)


    return (
        <div className={styles.container}>
            <div className={styles.heading}>
                <h1 className={styles.head}>
                    Total online drivers
                </h1>
                <button
                    className={styles.bbtn}
                    onClick={() => {
                        setCheckRadius(prev => !prev)
                    }}>
                    {checkRadius ? 'CLOSE DRIVER ZONE' : 'CHECK DRIVER ZONE'}
                </button>
            </div>
            <div className={styles.mapcontain}>
                <div className={styles.onlineDriverBox}>
                    Total online Drivers :<b style={{ color: 'green' }}>{locations?.length}</b>
                </div>
                <Map locations={locations}
                    radius={checkRadius}
                    polypoints={[]}
                    showName={true} />
            </div>
        </div >
    )
}

export default OnlineDriverslocation